import { envs } from '@/envs'

const sanitizeMethod = (method: string) => method.trim().replace(/^\/+|\/+$/g, '')

const normalizeRequestBaseUrl = (apiUrl: string) => {
  const trimmed = apiUrl.trim().replace(/\/+$/g, '')
  return trimmed.replace(/\/request(?:\.json)?$/i, '/request')
}

export const buildLegacyApiRequestUrl = (method: string) => {
  const sanitizedMethod = sanitizeMethod(method)
  if (!sanitizedMethod) {
    throw new Error('Legacy API method is required')
  }

  const baseUrl = normalizeRequestBaseUrl(envs.API_URL)
  return `${baseUrl}/${sanitizedMethod}.json`
}

export const buildLegacyApiRequestPayload = (
  body: Record<string, any> | undefined,
) => {
  if (!body || typeof body !== 'object') return {}

  const payload = { ...body }
  delete payload.method

  return payload
}
